import { ITrelloClient, TrelloMember } from "./trello-client.types";

export function stubTrelloClient({
    getMember = async () => stubTrelloMember()
}: Partial<ITrelloClient> = {}): ITrelloClient {
    return {
        getMember
    };
}

export function stubTrelloMember({
    id = "some-member-id",
    aaId = "some-member-aaId",
    username = "charlie",
    email = "charlie@atlassian.com",
    fullName = "Charles Atlas",
    credits = [],
    idPremOrgsAdmin = ["atlassian-org-id", "atlassian_marketing-org-id"],
    organizations = [
        {
            id: "atlassian-org-id",
            name: "atlassian",
            displayName: "Atlassian",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian"
        },
        {
            displayName: "BXP Dev Team",
            name: "bxpdevteam",
            id: "bxpdevteam-org-id",
            url: "https://trello.com/bxpdevteam"
        },
        {
            displayName: "BXPT",
            name: "bxpt",
            id: "bxpt-org-id",
            url: "https://trello.com/bxpt"
        },
        {
            displayName: "BXPT Trello",
            name: "bxptuser",
            id: "bxptuser-org-id",
            url: "https://trello.com/bxptuser"
        },
        {
            displayName: "Marketing",
            name: "atlassian_marketing",
            id: "atlassian_marketing-org-id",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian_marketing"
        },
        {
            displayName: "Web Team",
            name: "atlassianwebteam",
            id: "atlassianwebteam-org-id",
            url: "https://trello.com/atlassianwebteam"
        }
    ]
}: Partial<TrelloMember> = {}): TrelloMember {
    return {
        id,
        aaId,
        username,
        email,
        fullName,
        credits,
        idPremOrgsAdmin,
        organizations
    };
}

export function stubTrelloOnlyAdminMember({
    id = "some-member-id",
    aaId = "some-member-aaId",
    username = "charlie",
    email = "charlie@atlassian.com",
    fullName = "Charles Atlas",
    credits = [],
    idPremOrgsAdmin = ["atlassian-org-id", "atlassian_marketing-org-id"],
    organizations = [
        {
            id: "atlassian-org-id",
            name: "atlassian",
            displayName: "Atlassian",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian"
        },
        {
            displayName: "Marketing",
            name: "atlassian_marketing",
            id: "atlassian_marketing-org-id",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian_marketing"
        }
    ]
}: Partial<TrelloMember> = {}): TrelloMember {
    return {
        id,
        aaId,
        username,
        email,
        fullName,
        credits,
        idPremOrgsAdmin,
        organizations
    };
}

export function stubTrelloNonAdminMember({
    id = "some-member-id",
    aaId = "some-member-aaId",
    username = "charlie",
    email = "charlie@atlassian.com",
    fullName = "Charles Atlas",
    credits = [],
    idPremOrgsAdmin = ["atlassian-org-id", "atlassian_marketing-org-id"],
    organizations = [
        {
            id: "atlassian-org-id",
            name: "atlassian",
            displayName: "Atlassian",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "normal",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian"
        },
        {
            displayName: "BXP Dev Team",
            name: "bxpdevteam",
            id: "bxpdevteam-org-id",
            url: "https://trello.com/bxpdevteam"
        },
        {
            displayName: "BXPT",
            name: "bxpt",
            id: "bxpt-org-id",
            url: "https://trello.com/bxpt"
        },
        {
            displayName: "BXPT Trello",
            name: "bxptuser",
            id: "bxptuser-org-id",
            url: "https://trello.com/bxptuser"
        },
        {
            displayName: "Marketing",
            name: "atlassian_marketing",
            id: "atlassian_marketing-org-id",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "normal",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian_marketing"
        },
        {
            displayName: "Web Team",
            name: "atlassianwebteam",
            id: "atlassianwebteam-org-id",
            url: "https://trello.com/atlassianwebteam"
        }
    ]
}: Partial<TrelloMember> = {}): TrelloMember {
    return {
        id,
        aaId,
        username,
        email,
        fullName,
        credits,
        idPremOrgsAdmin,
        organizations
    };
}

export function stubTrelloMemberWithCredits({
    id = "some-member-id",
    aaId = "some-member-aaId",
    username = "charlie",
    email = "charlie@atlassian.com",
    fullName = "Charles Atlas",
    credits = ["gold"],
    idPremOrgsAdmin = ["atlassian-org-id", "atlassian_marketing-org-id"],
    organizations = [
        {
            id: "atlassian-org-id",
            name: "atlassian",
            displayName: "Atlassian",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian"
        },
        {
            displayName: "BXP Dev Team",
            name: "bxpdevteam",
            id: "bxpdevteam-org-id",
            url: "https://trello.com/bxpdevteam"
        },
        {
            displayName: "BXPT",
            name: "bxpt",
            id: "bxpt-org-id",
            url: "https://trello.com/bxpt"
        },
        {
            displayName: "BXPT Trello",
            name: "bxptuser",
            id: "bxptuser-org-id",
            url: "https://trello.com/bxptuser"
        },
        {
            displayName: "Marketing",
            name: "atlassian_marketing",
            id: "atlassian_marketing-org-id",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian_marketing"
        },
        {
            displayName: "Web Team",
            name: "atlassianwebteam",
            id: "atlassianwebteam-org-id",
            url: "https://trello.com/atlassianwebteam"
        }
    ]
}: Partial<TrelloMember> = {}): TrelloMember {
    return {
        id,
        aaId,
        username,
        email,
        fullName,
        credits,
        idPremOrgsAdmin,
        organizations
    };
}

export function stubTrelloMemberWithProducts({
    id = "some-member-id",
    aaId = "some-member-aaId",
    username = "charlie",
    email = "charlie@atlassian.com",
    fullName = "Charles Atlas",
    credits = [],
    idPremOrgsAdmin = ["atlassian-org-id", "atlassian_marketing-org-id"],
    organizations = [
        {
            id: "atlassian-org-id",
            name: "atlassian",
            displayName: "Atlassian",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian",
            products: [110]
        },
        {
            displayName: "BXP Dev Team",
            name: "bxpdevteam",
            id: "bxpdevteam-org-id",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/bxpdevteam",
            products: []
        },
        {
            displayName: "BXPT",
            name: "bxpt",
            id: "bxpt-org-id",
            url: "https://trello.com/bxpt"
        },
        {
            displayName: "BXPT Trello",
            name: "bxptuser",
            id: "bxptuser-org-id",
            url: "https://trello.com/bxptuser"
        },
        {
            displayName: "Marketing",
            name: "atlassian_marketing",
            id: "atlassian_marketing-org-id",
            memberships: [
                {
                    id: "some-id",
                    idMember: "some-member-id",
                    memberType: "admin",
                    unconfirmed: false,
                    deactivated: false
                }
            ],
            url: "https://trello.com/atlassian_marketing",
            products: [107]
        },
        {
            displayName: "Web Team",
            name: "atlassianwebteam",
            id: "atlassianwebteam-org-id",
            url: "https://trello.com/atlassianwebteam"
        }
    ]
}: Partial<TrelloMember> = {}): TrelloMember {
    return {
        id,
        aaId,
        username,
        email,
        fullName,
        credits,
        idPremOrgsAdmin,
        organizations
    };
}
